import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useAppDispatch, useAppSelector } from "~/app/store";
import { useBarcodeScanner } from "~/lib/barCodeScan";
import { getBarcodeValue } from "~/lib/helpers";
import { mixpanelTrack, useMixpanelPageName } from "~/lib/mixpanel-tracking";

import {
  selectLotNumber,
  setLotNumber,
  selectIsLotNumberFieldFocused,
  setIsLotNumberFieldFocused,
  selectIsPreviousBinFlow
} from "./autostorePutaway.slice";

export function LotNumberField({ isRequired }: { isRequired: boolean }) {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const trackedPageName = useMixpanelPageName();
  const lotNumber = useAppSelector(selectLotNumber);
  const isLotNumberFieldFocused = useAppSelector(selectIsLotNumberFieldFocused);
  const isPreviousBinFlow = useAppSelector(selectIsPreviousBinFlow);

  useBarcodeScanner({
    findScanMatch: (buffer: string) => {
      const barcodeValue = getBarcodeValue(buffer);
      mixpanelTrack({
        trackedPageName,
        type: "Scan",
        label: "Lot Number",
        eventProperties: {
          "Lot Number": barcodeValue
        }
      });
      dispatch(setLotNumber(barcodeValue));
    },
    disabled: !isLotNumberFieldFocused,
    shouldBlurInputs: false
  });

  return (
    <TextField
      label={t("lot number")}
      value={lotNumber}
      error={isRequired && !lotNumber}
      disabled={isPreviousBinFlow}
      onChange={(event) => {
        dispatch(setLotNumber(event.target.value));
      }}
      onFocus={() => dispatch(setIsLotNumberFieldFocused(true))}
      onBlur={() => {
        if (lotNumber) {
          mixpanelTrack({
            trackedPageName,
            type: "Input Change",
            label: "Lot Number",
            eventProperties: {
              "Lot Number": lotNumber
            }
          });
        }
        dispatch(setIsLotNumberFieldFocused(false));
      }}
      variant="outlined"
      slotProps={{
        inputLabel: { shrink: true }
      }}
      sx={{
        ".MuiInputBase-input": {
          fontSize: "22px"
        }
      }}
    />
  );
}

export default LotNumberField;
